<template>
  <EUIPageLoading />
</template>

<script>
import { getEnv } from 'ecx.saigon.ui.common';
import EUIPageLoading from '@eui-page/loading';

export default {
  name: 'VehicleOrderedWidget',
  metaInfo: {
    title: 'Vehicle Ordered |'
  },
  async mounted() {
    const env = await getEnv();
    window.location = env.VUE_APP_SETTLEMENT_ROUTE;
  },
  components: {
    EUIPageLoading
  }
};
</script>
